import React from 'react'
import { object, func } from 'prop-types'
import { translate } from 'react-i18next'
import moment from 'moment'
import { ProfilePicture } from '../../../components/ui/ProfilePicture'
import { InterventionReport } from './InterventionReport'
import { ProposalStatus } from '../../../constants/ProposalStatus'

export const ProposalAcceptedComponent = ({ proposal, t }) => {
  const mapDateMonthlyInterventionsToCount = proposal.maintenance.interventions.reduce((acc, intervention) => {
    if (intervention.monthly) {
      const date = moment.unix(intervention.interventionDate).format('MMMM YYYY')
      const dateCapitalized = date.charAt(0).toUpperCase() + date.slice(1)
      acc[dateCapitalized] = acc[dateCapitalized] ? acc[dateCapitalized] + 1 : 1
    }
    return acc
  }, {})
  return <div className="demandes__section">
    <div>
      <div className="demande__section">
        <p className="demandes__mainlabel">{t('common:visits:your_gardener')}</p>
        <div className="demande__flex demande__flex--justifystart">
          <ProfilePicture size={120} picture={proposal.profilePicture} className="img--avatar" alt="picture"/>
          <p className="demandes__gardener-name">{proposal.name}</p>
        </div>
      </div>
      {
        proposal.status === ProposalStatus.ACCEPTED &&
        <div className="demande__section ">
          <p className="demandes__mainlabel">{t('common:visits:next_intervention')}</p>
          {
            proposal.maintenance.interventions.map((intervention, index) => {
              return !intervention.done && !intervention.monthly
                ? (<p className="demandes__currenttext"
                      key={index}>{t('common:visits:gardening_service')} - {moment.unix(intervention.interventionDate).format('LLLL')}</p>)
                : ''
            })
          }
          {
            mapDateMonthlyInterventionsToCount && Object.keys(mapDateMonthlyInterventionsToCount).map((date, index) => {
              return (<p className="demandes__currenttext"
                         key={index}>{date} - {t('common:visits:count_appointments', { count: mapDateMonthlyInterventionsToCount[date] })}</p>)
            })
          }
        </div>
      }
      <div className="demande__section demande__flex demande__flex--justifystart">
        <div>
          <p className="demandes__mainlabel">{t('common:visits:nb_hours_expected')}</p>
          <p className="demandes__currenttext">{proposal.maintenance.nbHours}</p>
        </div>
        <div className="demande__item">
          <p className="demandes__mainlabel">{t('common:visits:nb_hours_left')}</p>
          <p className="demandes__currenttext">{proposal.maintenance.nbHoursLeft}</p>
        </div>
      </div>
      {(proposal.maintenance.interventions.filter((intervention) => intervention.done).length > 0) &&
        <div className="demande__section ">
          <p className="demandes__mainlabel">{t('common:visits:previous_intervention')}</p>
          {
            proposal.maintenance.interventions.map((intervention, index) => {
              return intervention.done
                ? (<InterventionReport intervention={intervention} index={index} key={index} t={t}/>)
                : ''
            })
          }
        </div>
      }
      <div className="demande__section ">
        <p className="demandes__mainlabel">{t('common:visits:payment_terms')}</p>
        <div className="demande__flex">
          <div>
            <p className="demande__secondlabel">{t('common:visits:first_payment')}</p>
            <p className="demandes__currenttext">{moment.unix(proposal.maintenance.firstPaymentDate).format('LL')}</p>
          </div>
          <div>
            <p className="demande__secondlabel">{t('common:visits:last_payment')}</p>
            <p className="demandes__currenttext">{moment.unix(proposal.maintenance.lastPaymentDate).format('LL')}</p>
          </div>
          <div>
            <p className="demande__secondlabel">{t('common:visits:frequency')}</p>
            <p className="demandes__currenttext">{proposal.maintenance.periodicity === 1 ? 'Mensuelle' : ''}</p>
          </div>
        </div>
      </div>
      <div className="demande__section demande__section--last">
        <p className="demandes__mainlabel">{t('common:visits:payment_deadlines')}</p>
        {proposal.maintenance.paymentMaturities.map((paymentMaturitie, index) => {
          return (
            <div className="demande__flex" key={index}>
              <p className="demande__secondlabel">{moment.unix(paymentMaturitie.paymentDate).format('LL')}</p>
              <p className="demande__secondlabel demande__secondlabel--price">{paymentMaturitie.amount}€</p>
            </div>
          )
        })}
      </div>
    </div>
  </div>
}

ProposalAcceptedComponent.propTypes = {
  t: func,
  proposal: object
}

export const ProposalAccepted = translate()(ProposalAcceptedComponent)



// WEBPACK FOOTER //
// ./src/pages/demandes/maintenances/ProposalAccepted.js